








































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { PaginationModel } from "@/models/commons/PaginationModel";
import { estadosList, EstadoModel } from "@/models/commons/EstadoModel";
import PrecoFiltro from "@/models/cadastros/assistencia/precificacao/PrecoFiltro";
import PrecoModel from "@/models/cadastros/assistencia/precificacao/PrecoModel";
import { tiposServicoList } from "@/models/cadastros/assistencia/TipoServicoModel";
import { tiposVeiculoList } from "@/models/cadastros/assistencia/TipoVeiculoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { servicosSaudeCidadesApi } from "../../../../../api/ServicosSaudeCidadesApi";
import { servicosSaudeBairrosApi } from "../../../../../api/ServicosSaudeBairro";
import CidadeModel from "@/models/cadastros/saude/CidadeModel";
import { BairroModel } from "@/models/cadastros/saude/BairroModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog
  },
})
export default class ListaPrecificacoes extends Vue {
  $refs!: {
    filtroObserver: InstanceType<typeof ValidationObserver>;
  };

  cidades: CidadeModel[] = [];
  bairros: BairroModel[] = [];

  cidade: CidadeModel = {};

  estados = estadosList;
  especialidades: [] = [];
  precos: [] = [];
  loading = false;
  filtro: PrecoFiltro = {};
  tiposServico = tiposServicoList;
  tiposVeiculo = tiposVeiculoList;
  cidadesFiltro = [];
  bairrosFiltro: string[] = [];
  bairrosSelecionados = [];

  dialogType = '';
  dialogTitle = '';
  dialogMessage = '';
  exclusaoDialog = false;
  showDialog = false;


  options: PaginationModel = {
    itemsPerPage: 5,
    page: 1,
    itemsLength: 0,
  };
  cabecalho = [
    { text: "Tipo de serviço", value: "tipoServico", width: "15%" },
    { text: "Tipo veículo", value: "tipoVeiculo", width: "12%" },
    { text: "Estado", value: "estado", width: "8%" },
    { text: "Cidade", value: "cidade", width: "15%" },
    { text: "Bairro", value: "bairro", width: "20%" },
    { text: "Valor final", value: "valorFinal", width: "20%" },
    { text: "Ações", value: "actions", sortable: false, width: "10%" },
  ];

  filtrar() {
    if (!!Object.values(this.filtro).filter(value => !!value).length) {
      this.loading = true;
      ServicosAssistenciaService.pesquisarPrecos(this.filtro)
        .then((res: any) => {
          this.precos = res.data.content;
          this.options.itemsLength = res.totalElements;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    } else {
      this.openDialog('info', 'Aviso!', 'Informe pelo menos um filtro!');
    }
  }

  @Watch("options.page")
  @Watch("options.itemsLength")
  handlePagination() {
    this.filtrar();
  }

  precoExclusao: PrecoModel = {};

  excluirPreco(preco: PrecoModel) {
    this.precoExclusao = preco;
    this.exclusaoDialog = true;
    console.log(preco);
    this.openDialog('confirm', 'Confimação de exclusão', `Deseja realmente excluir o preço ${preco.tipoServico}?`);
  }

  excluir() {
    if (this.precoExclusao?.id) {
      ServicosAssistenciaService.deletarPreco(this.precoExclusao?.id).then(
        (res) => {
          this.openDialog('success', 'Sucesso', 'Excluído com sucesso.');
          this.exclusaoDialog = false;
          this.filtrar();
        },
        (err) => {
          this.openDialog('error', 'Erro', err);
        }
      );
    }
  }

  changeEstado(estado: EstadoModel) {
    servicosSaudeCidadesApi
      .obterCidadesPorEstado(estado.sigla)
      .then(cidades => {
        this.cidadesFiltro = cidades.map((cidade: CidadeModel) => {
          return cidade.nome;
        });
      });
  }

  changeCidade(cidade: string) {
    if (cidade) {
      servicosSaudeBairrosApi.obterBairrosPorCidade(cidade).then(bairros => {
        this.bairrosFiltro = bairros.map((bairro: BairroModel) => {
          return bairro.nome;
        });
      });
    }
  }

  changeBairo(bairro: string[]) {
    const teste = bairro
      .map((bar: string) => {
        return bar;
      })
      .join(",");

    Vue.set(this.filtro, "bairro", teste);
  }

  clearFilters() {
    this.cidadesFiltro = [];
    this.bairrosFiltro = [];
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
    if (this.dialogType === 'success') {
      this.filtrar();
    }
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "confirm":
      case "error":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
